import * as actionTypes from '../constants/action-types';
import { defaultAgent, apiResponse } from '../helpers/web-agent';
import { toastError, toastSuccess } from './toast';
import { tokenExpired } from './auth';
import {
    USER_CREATED, USER_EDITED, USER_DELETED, USER_LOGIN_EXISTS, USER_AUTH_ADDED, USER_AUTH_EXISTS,
    USER_FARM_ASSIGNED, USER_PASSWORD_RESETED, USER_INVALID_CURRENT_PASSWORD, USER_ROLE_PERMISSION_UPDATED, USER_PERMISSION_UPDATED
} from '../constants/messages';
const toastOptions = { position: "top-left" };

//USERS
export const userListRequest = () => ({ type: actionTypes.USER_LIST_REQUEST });

export const roleListRequest = () => ({ type: actionTypes.USER_GET_ROLE_LIST_REQUEST });

export const roleList = data => ({ type: actionTypes.USER_GET_ROLE_LIST, payload: data });

export const userList = data => ({ type: actionTypes.USER_GET_USER_LIST, payload: data });

export const userFarmListRequest = (userId) => ({ type: actionTypes.USER_GET_USER_FARM_LIST_REQUEST, userId });

export const userFarmList = (userId, data) => ({ type: actionTypes.USER_GET_USER_FARM_LIST, userId, payload: data });

export const farmListRequest = () => ({ type: actionTypes.USER_GET_FARM_LIST_REQUEST });

export const farmList = data => ({ type: actionTypes.USER_GET_FARM_LIST, payload: data });

export const authProviderListRequest = () => ({ type: actionTypes.USER_GET_AUTH_PROVIDER_LIST_REQUEST });

export const authProviderList = (data) => ({ type: actionTypes.USER_GET_AUTH_PROVIDER_LIST, payload: data });

export const authListRequest = () => ({ type: actionTypes.USER_GET_AUTH_LIST_REQUEST });

export const authList = (data) => ({ type: actionTypes.USER_GET_AUTH_LIST, payload: data });

export const rolePermissionListrequest = () => ({ type: actionTypes.USER_GET_ROLE_PERMISSION_LIST_REQUEST });

export const rolePermissionList = (data) => ({ type: actionTypes.USER_GET_ROLE_PERMISSION_LIST, payload: data });

export const controllerListrequest = () => ({ type: actionTypes.USER_GET_CONTROLLER_LIST_REQUEST });

export const controllerList = (data) => ({ type: actionTypes.USER_GET_CONTROLLER_LIST, payload: data });

export const updateRolePermission = (data) => ({ type: actionTypes.USER_UPDATE_ROLE_PERMISSION, payload: data });

export const userPermissionRequest = (userId) => ({ type: actionTypes.USER_GET_USER_PERMISSION_REQUEST, userId });

export const userPermission = (userId, data) => ({ type: actionTypes.USER_GET_USER_PERMISSION, userId, payload: data });

export const updateUserPermission = (data) => ({ type: actionTypes.USER_UPDATE_USER_PERMISSION, payload: data });

export const getRoleList = (cb = null) => dispatch => {
    dispatch(roleListRequest());
    defaultAgent.get('/api/role/list')
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message, toastOptions));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message, toastOptions));
                dispatch(roleList([]));
            } else if (agentResult.data) {
                if (cb) cb()
                dispatch(roleList(agentResult.data));
            }
        })
        .catch(ex => {
            dispatch(toastError(ex.message, toastOptions));
            dispatch(roleList([]));
        });
};

export const getUserList = (haveRequest = true, cb = null) => dispatch => {
    if (haveRequest) dispatch(userListRequest());
    defaultAgent.get('/api/user/list')
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message, toastOptions));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message, toastOptions));
                dispatch(userList([]));
            } else if (agentResult.data) {
                dispatch(userList(agentResult.data));
                dispatch(getAuthList());
                if (cb) cb();
            }
        })
        .catch(ex => {
            dispatch(toastError(ex.message, toastOptions));
            dispatch(userList([]));
        });
};

export const getFarmList = () => dispatch => {
    dispatch(farmListRequest());
    defaultAgent.get('/api/farm/list')
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message, toastOptions));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message, toastOptions));
                dispatch(farmList([]));
            } else if (agentResult.data) {
                dispatch(farmList(agentResult.data));
            }
        })
        .catch(ex => {
            dispatch(toastError(ex.message, toastOptions));
            dispatch(farmList([]));
        });
};

export const getUserFarmList = (userId) => dispatch => {
    dispatch(userFarmListRequest(userId));
    defaultAgent.get('/api/user/farm/assigned', { user_id: userId })
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message, toastOptions));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message, toastOptions));
                dispatch(userFarmList(userId, []));
            } else if (agentResult.data) {
                dispatch(userFarmList(userId, agentResult.data));
            }
        })
        .catch(ex => {
            dispatch(toastError(ex.message, toastOptions));
            dispatch(userFarmList(userId, []));
        });
};

export const createUser = (data, cb = null) => dispatch => {
    defaultAgent.post('/api/user/add', data)
        .then(res => {
            const agentResult = apiResponse(res, {});
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message, toastOptions));
                dispatch(tokenExpired());
            } else if (agentResult.code === USER_CREATED.code) {
                dispatch(toastSuccess(agentResult.message, toastOptions));
                if (cb) cb(true);
                dispatch(getUserList(false));
            } else if (agentResult.code === USER_LOGIN_EXISTS.code) {
                if (cb) cb(false, agentResult.message);
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message, toastOptions));
                if (cb) cb(false);
            }
        }).catch(ex => {
            dispatch(toastError(ex.message, toastOptions));
            if (cb) cb(false);
        });
};

export const assignFarm = (params, cb = null) => dispatch => {
    defaultAgent.put('/api/user/farm/assign', params)
        .then(res => {
            const agentResult = apiResponse(res, {});
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message, toastOptions));
                dispatch(tokenExpired());
            } else if (agentResult.code === USER_FARM_ASSIGNED.code) {
                dispatch(getUserFarmList(params.user_id));
                if (cb) cb(true);
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message, toastOptions));
                if (cb) cb(false);
            }
        }).catch(ex => {
            dispatch(toastError(ex.message, toastOptions));
            if (cb) cb(false);
        });
};

export const editUser = (data, cb = null) => dispatch => {
    defaultAgent.put('/api/user/edit', data)
        .then(res => {
            const agentResult = apiResponse(res, {});
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message, toastOptions));
                dispatch(tokenExpired());
            } else if (agentResult.code === USER_EDITED.code) {
                dispatch(toastSuccess(agentResult.message, toastOptions));
                if (cb) cb(true);
                dispatch(getUserList(false));
            } else if (agentResult.code === USER_LOGIN_EXISTS.code) {
                if (cb) cb(false, agentResult.message);
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message, toastOptions));
                if (cb) cb(false);
            }
        }).catch(ex => {
            dispatch(toastError(ex.message, toastOptions));
            if (cb) cb(false);
        });
};

export const resetPassword = (data, cb = null) => dispatch => {
    defaultAgent.put('/api/user/resetpassword', data)
        .then(res => {
            const agentResult = apiResponse(res, {});
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message, toastOptions));
                dispatch(tokenExpired());
            } else if (agentResult.code === USER_PASSWORD_RESETED.code) {
                dispatch(toastSuccess(agentResult.message, toastOptions));
                if (cb) cb(true);
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message, toastOptions));
                if (cb) cb(false);
            }
        }).catch(ex => {
            dispatch(toastError(ex.message, toastOptions));
            if (cb) cb(false);
        });
};

export const changePassword = (params, cb = null) => dispatch => {
    defaultAgent.put('api/user/changepassword', params)
        .then(res => {
            const agentResult = apiResponse(res, {});
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message, toastOptions));
                dispatch(tokenExpired());
            } else if (agentResult.code === USER_PASSWORD_RESETED.code) {
                dispatch(toastSuccess(agentResult.message, toastOptions));
                if (cb) cb(true);
            } else if (agentResult.code === USER_INVALID_CURRENT_PASSWORD.code) {
                if (cb) cb(false, agentResult.message);
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message, toastOptions));
                if (cb) cb(false);
            }
        }).catch(ex => {
            dispatch(toastError(ex.message, toastOptions));
            if (cb) cb(false);
        });
};

export const deleteUser = (userId, cb = null) => dispatch => {
    defaultAgent.put('/api/user/delete', { user_id: userId })
        .then(res => {
            const agentResult = apiResponse(res, {});
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message, toastOptions));
                dispatch(tokenExpired());
            } else if (agentResult.code === USER_DELETED.code) {
                dispatch(toastSuccess(agentResult.message, toastOptions));
                dispatch(getUserList(false));
                if (cb) cb();
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message, toastOptions));
            }
        }).catch(ex => {
            dispatch(toastError(ex.message, toastOptions));
        });
};

export const addAuthentication = (params, cb = null) => dispatch => {
    defaultAgent.post('api/user/add/authentication', params)
        .then(res => {
            const agentResult = apiResponse(res, {});
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message, toastOptions));
                dispatch(tokenExpired());
            } else if (agentResult.code === USER_AUTH_ADDED.code) {
                if (cb) cb(agentResult.message, true);
                dispatch(getAuthList());
            } else if (agentResult.code === USER_AUTH_EXISTS.code) {
                if (cb) cb(agentResult.message, false);
            } else if (agentResult.message) {
                if (cb) cb(agentResult.message, false);
            }
        }).catch(ex => {
            dispatch(toastError(ex.message, toastOptions));
        });
};

export const getAuthProviderList = () => dispatch => {
    dispatch(authProviderListRequest());
    defaultAgent.get('api/user/authenticationprovider/list')
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message, toastOptions));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message, toastOptions));
                dispatch(authProviderList([]));
            } else if (agentResult.data) {
                dispatch(authProviderList(agentResult.data));
            }
        })
        .catch(ex => {
            dispatch(toastError(ex.message, toastOptions));
            dispatch(authProviderList([]));
        });
};

export const getAuthList = () => dispatch => {
    dispatch(authListRequest());
    defaultAgent.get('api/user/authentication/list')
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message, toastOptions));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message, toastOptions));
                dispatch(authList([]));
            } else if (agentResult.data) {
                dispatch(authList(agentResult.data));
            }
        })
        .catch(ex => {
            dispatch(toastError(ex.message, toastOptions));
            dispatch(authList([]));
        });
};


export const getUserAuthProviderList = (cb) => dispatch => {
    dispatch(authListRequest());
    defaultAgent.get('api/user/authenticationproviders')
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message, toastOptions));
                dispatch(tokenExpired());
                if (cb) cb(null);
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message, toastOptions));
                if (cb) cb(null);
            } else if (agentResult.data) {
                if (cb) cb(agentResult.data);
            }
        })
        .catch(ex => {
            dispatch(toastError(ex.message, toastOptions));
            if (cb) cb(null);
        });
};

export const getRolePermissionList = (cb = null) => dispatch => {
    dispatch(rolePermissionListrequest());
    defaultAgent.get('api/role/permission')
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message, toastOptions));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message, toastOptions));
                dispatch(rolePermissionList([]));
            } else if (agentResult.data) {
                if (cb) cb();
                dispatch(rolePermissionList(agentResult.data));
            }
        })
        .catch(ex => {
            dispatch(toastError(ex.message, toastOptions));
            dispatch(rolePermissionList([]));
        });
};

export const getControllerList = () => dispatch => {
    dispatch(controllerListrequest());
    defaultAgent.get('api/user/controller/list')
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message, toastOptions));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message, toastOptions));
                dispatch(controllerList([]));
            } else if (agentResult.data) {
                dispatch(controllerList(agentResult.data));
            }
        })
        .catch(ex => {
            dispatch(toastError(ex.message, toastOptions));
            dispatch(controllerList([]));
        });
};

export const enableRolePermission = (params, cb = null) => dispatch => {
    const requestId = `enable_permission_${params.role_id}_${params.controller_id}_${params.action_id}`;
    defaultAgent.put('api/role/permission/enable', params, { requestId: `users_${requestId}` })
        .then(res => {
            const agentResult = apiResponse(res, {});
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message, toastOptions));
                dispatch(tokenExpired());
            } else if (agentResult.code === USER_ROLE_PERMISSION_UPDATED.code) {
                dispatch(updateRolePermission(params));
                if (cb) cb(true);
            } else if (agentResult.message) {
                if (cb) cb(false);
                dispatch(toastError(agentResult.message, toastOptions));
            }
        }).catch(ex => {
            if (defaultAgent.isCancel(ex)) return console.log(`Users enable role permission: `, ex.message);
            if (cb) cb(false);
            dispatch(toastError(ex.message, toastOptions));
        });
};

export const getUserPermission = (userId) => dispatch => {
    dispatch(userPermissionRequest(userId));

    defaultAgent.get('api/user/permission', { user_id: userId })
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message, toastOptions));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message, toastOptions));
                dispatch(userPermission(userId));
            } else if (agentResult.data) {
                dispatch(userPermission(userId, agentResult.data[0]));
            }
        })
        .catch(ex => {
            dispatch(toastError(ex.message, toastOptions));
            dispatch(userPermission(userId));
        });
};

export const enableUserPermission = (params, cb = null) => dispatch => {
    const requestId = `enable_permission_${params.user_id}_${params.controller_id}_${params.action_id}`;
    defaultAgent.put('api/user/permission/enable', params, { requestId: `users_${requestId}` })
        .then(res => {
            const agentResult = apiResponse(res, {});
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message, toastOptions));
                dispatch(tokenExpired());
            } else if (agentResult.code === USER_PERMISSION_UPDATED.code) {
                dispatch(updateUserPermission(params));
                if (cb) cb(true);
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message, toastOptions));
                if (cb) cb(false);
            }
        }).catch(ex => {
            if (defaultAgent.isCancel(ex)) return console.log(`Users enable permission: `, ex.message);
            dispatch(toastError(ex.message, toastOptions));
            if (cb) cb(false);
        });
};